import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Button } from "@mui/material";

const RouterLinkButton = (props) => {
  const { primary, to, variant, color, size, type, startIcon, disableRipple } = props;

  return (
    <Button
      component={RouterLink}
      to={to}
      size={size}
      type={type}
      startIcon={startIcon}
      variant={variant}
      color={color}
      disableRipple={disableRipple}
      aria-label={primary}
    >
      {primary}
    </Button>
  );
};

export default RouterLinkButton;
